<div *ngIf="balance" [ngClass]="color">
    <span *ngIf="sign">{{ sign }}</span>
    <td-tez *ngIf="balance" [value]="balance"></td-tez>
</div>
